import { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";

import Topbar from './components/Topbar';
import Sidebar from "./components/Sidebar";
import FloatingTokenReportCard from "../../admin/components/report/FloatingTokenReportCard";

const UserFloatingTokenReport = ({ token, distributor }) => {

	const history = useHistory();

	const [toggled, setToggled] = useState(false);

	useEffect(() => {
		if (!distributor || !distributor.floating_token_report) {
			history.push('/distributor')
		}
	}, [])

	const handleToggle = () => {
		setToggled(!toggled);
	}

	return (
		<div className="admin-page-container">
			<Sidebar toggled={toggled} setToggled={handleToggle} />
			<div className="admin-page">
				<Topbar handleToggle={handleToggle} />
				<div className="admin-content">
					<FloatingTokenReportCard
						token={token}
						role="distributor"
					/>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = state => {
	return {
		distributor: state.distributor.distributor,
		token: state.distributor.token
	};
};

export default connect(mapStateToProps, null)(UserFloatingTokenReport);
